import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { FunctionComponent } from 'react'
import { Colors } from '~/assets/style/colors'
import { Fonts } from '~/assets/style/fonts'
import Button from '~/components/Button'
import { IconName } from '~/components/Icon'
import { TrackingLabel } from '~/components/layout/ProductTrackingIntegration'

const Card = styled.div<{ disabled?: boolean }>`
  background-color: ${Colors.White};
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 19px 12px;
  ${({ disabled }) =>
    disabled
      ? css`
          background-color: ${Colors.Platinum};
        `
      : css`
          background-color: ${Colors.White};
        `};
`

const Title = styled.div`
  grid-area: title;
  display: flex;
  gap: 2px;
  align-items: center;
  margin-top: 2px;
`

const Name = styled.div<{ disabled?: boolean }>`
  ${Fonts.colors.Jet};
  ${Fonts.P1};
  font-weight: bold;

  ${({ disabled }) =>
    disabled &&
    css`
      color: ${Colors.Silver};
    `}
`

const Description = styled.div<{ disabled?: boolean }>`
  grid-area: description;
  ${Fonts.colors.Jet};
  ${Fonts.P2};
  margin-bottom: 4px;
  ${({ disabled }) =>
    disabled &&
    css`
      color: ${Colors.Silver};
    `}
`

const ActionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 6px;
  align-items: center;
  justify-content: flex-end;
`

export type OnboardingCardProps = {
  name: string
  description: string
  buttonsProps: {
    label: string
    trackingLabel: TrackingLabel
    onClick: () => void
    variant: 'primary' | 'secondary' | 'tertiary'
    iconName?: IconName
  }[]
  disabled?: boolean
}
export const OnboardingCard: FunctionComponent<OnboardingCardProps> = ({ name, description, buttonsProps, disabled }) => (
  <Card disabled={disabled}>
    <div>
      <Title>
        <Name disabled={disabled}>{name}</Name>
      </Title>
      <Description disabled={disabled}>{description}</Description>
    </div>
    <ActionWrapper>
      {buttonsProps.map((buttonProps) => (
        <Button key={buttonProps.label} disabled={disabled} iconName={buttonProps.iconName} variant={buttonProps.variant} trackingLabel={buttonProps.trackingLabel} onClick={buttonProps.onClick}>
          {buttonProps.label}
        </Button>
      ))}
    </ActionWrapper>
  </Card>
)
